import Formulario from "../components/view-parts/empresas/formulario.vue";

export default {
  es: {
    hogar: {
      hero: {
        title: "TARIFA GAS",
        subtitle: "Hogar",
        description: "Te presentamos las tarifas de GAS de Iner.",
        concept:
          "Ofrecemos un suministro transparente y adaptado a tu consumo diario. La confianza de siempre, ahora también en tu suministro de gas.",
        featured: {
          title: "TU TARIFA <strong>GAS</strong>",
          description: "a precio de coste + ",
          price: "€ / mes",
          label: "CUOTA FIJA MENSUAL",
        },
        visual: "Gas a precio <br> de un batido",
      },
      mainTitle: {
        title: "NUESTRAS TARIFAS",
        subtitle: "UNA TARIFA PARA CADA NECESIDAD...",
      },
      tarifas: {
        tarifaRL1: {
          id: "RL1",
          btn: "RL.1",
          number: "1",
          title: "TARIFA",
          type: "RL.1",
          description: "Esta tarifa es para ti si...",
          bulletPoints1:
            "Si consumes en la franja de 0 a 5.000 kWh <span style='font-weight: 400;'>(estarás pensando, ¿y yo que se lo que consumo?</span>",
          bulletPoints2:
            "Para que lo entiendas mejor, esta tarifa es la de aquellos hogares que tienen un consumo de gas reducido.",
          bulletPoints3:
            "Por ejemplo casas que disponen de un calentador de agua y una cocina de gas pero que NO tienen calefacción.",
          consumption: {
            title: "TU CONSUMO",
            note: "El precio del KW no cambiará durante todo el año.",
          },
          cost: {
            title: "TÉRMINO FIJO",
            note: "Cuota obligatoria del estado.",
          },
          explanation:
            "<span style='text-align: center;'>?</span>¿No lo entiendes? Te lo explicamos <b class='-dark-orange'>aquí</b>",
          explanationContent: {
            title: "¿No lo entiendes?",
            subtitle: "Es normal, a nosotros también nos costó al principio...",
            question1: "¿Qué es el coste variable?",
            answer1:
              "El coste variable es tu consumo. Es decir el coste correspondiente a los KW que consumas.",
            question2: "¿Qué es el coste fijo?",
            answer2:
              "El coste fijo es una cuota oficial que marca el gobierno y que se cobrará todos los meses aunque no gastes nada.",
          },
          features: [
            "Alta online sin papeleos",
            "Sin permanencia",
            "3,65 €/mes + gas a precio de coste",
          ]
        },
        tarifaRL2: {
          id: "RL2",
          btn: "RL.2",
          number: "2",
          title: "TARIFA",
          type: "RL.2",
          description: "Esta tarifa es para ti si...",
          bulletPoints: [
            "Si tienes un consumo entre 5.000 y 15.000 kWh anuales.",
            "Eres de los que entienden que esta tarifa está frecuentemente propia de tarifas especiales como apartamentos o calefacción.",
          ],
          consumption: {
            title: "TU CONSUMO",
            price: "0,151 €/kWh",
            note: "Precio fijo 24h",
          },
          cost: {
            title: "TÉRMINO FIJO",
            price: "7,85 €/mes",
            note: "Cuota mensual de gestión",
          },
          button: "¡CONTRÁTALA!",
          features: [
            "Alta online sin papeleos",
            "Sin permanencia",
            "3,65 €/mes + gas a precio de coste",
          ]
        },
        tarifaRL3: {
          id: "RL3",
          btn: "RL.3",
          number: "3",
          title: "TARIFA",
          type: "RL.3",
          description: "Esta tarifa es para ti si...",
          bulletPoints: [
            "Si tienes un consumo entre 15.000 kWh y 50.000 kWh anuales.",
            "Tarifa menos frecuente, propia de casas con mucho consumo de gas.",
          ],
          consumption: {
            title: "TU CONSUMO",
            price: "0,151 €/kWh",
            note: "Precio fijo 24h",
          },
          cost: {
            title: "TÉRMINO FIJO",
            price: "XXX €/mes",
            note: "Cuota mensual de gestión",
          },
          button: "¡CONTRÁTALA!",
          features: [
            "Alta online sin papeleos",
            "Sin permanencia",
            "3,65 €/mes + gas a precio de coste",
          ]
        }
      }

    },
    empresa: {
      hero: {
        title: "TARIFA GAS",
        subtitle: "Empresa",
        description: "Te presentamos las tarifas de GAS para empresas de Iner",
        concept:
          "Si quieres que uno de nuestros asesores te realice un estudio personalizado ponte en contacto con nosotros y estudiamos tu caso para ver qué es lo mejor para tu negocio. ",
      },
      tarifas:{
        tarifaRL4: {
          id: "RL4",
          btn: "RL.4",
          number: "1",
          title: "TARIFA",
          type: "RL.4",
          description: "Esta tarifa es para ti si...",
          bulletPoints1:
            "Tu consumo anual de gas está entre 50.000 y 300.000 kWh, ideal para pymes y negocios con demanda moderada.",
          bulletPoints2:
            "Buscas un precio competitivo que te ayude a controlar y reducir los costes energéticos.",
          bulletPoints3:
            "Quieres una tarifa con condiciones claras y sin sorpresas, perfecta para empresas con uso regular de gas en sus instalaciones.",
          btn: "RL.4",
          cost: {
            title: "TÉRMINO FIJO",
            price: "7,85 €/mes",
            note: "Cuota mensual de gestión",
          },
        },
        tarifaRL5: {
          id: "RL5",
          btn: "RL.5",
          number: "2",
          title: "TARIFA",
          type: "RL.5",
          description: "Esta tarifa es para ti si...",
          bulletPoints1:
            "Tu consumo anual de gas está entre 300.000 y 1.500.000 kWh, y necesitas una tarifa diseñada para grandes volúmenes.",
          bulletPoints2:
            "Buscas un precio muy competitivo que reduzca significativamente los costes energéticos en procesos industriales o de calefacción intensiva.",
          bulletPoints3:
            "Quieres condiciones transparentes y flexibles, ideales para plantas, fábricas o instalaciones con demanda constante y elevada.",
          btn: "RL.5",
          cost: {
            title: "TÉRMINO FIJO",
            price: "7,85 €/mes",
            note: "Cuota mensual de gestión",
          },
        }
      },
      formulario: {
        title: "¿Quieres un presupuesto más personalizado?",
        description:
          "Adjuntanos tu última factura y realizaremos el estudio en cuestión de horas.",
        placeholder: "Adjunta tu factura actual",
        btnAttach: "Adjuntar",
        addAnotherFile: "Añadir otro fichero",
        businessAppointment:
          "Quiero concertar una cita con un comercial de iner",
        privacyPolicyText: "Al enviar el formulario está aceptando nuestra",
        privacyPolicy: "Política de Privacidad",
        successMessage: "¡Nos pondremos en contacto contigo lo antes posible!",
      },
    },
  },
  en: {},
};



// WEBPACK FOOTER //
// ./src/translations/tarifa-gas.js